import React, { useState } from "react";
import { Card, Tab, Nav } from "react-bootstrap";
import PageTitle from "../layouts/PageTitle";
import UsersTable from "./UsersTable";
import { useLocation } from "react-router-dom";
import SendMessages from "./SendMessages";

export default function SendMessageList() {
  const location = useLocation();

  return (
    <div>
      <PageTitle activeMenu="Message" motherMenu="Send Message" />
      <Card>
        <Card.Body>
          <div className="default-tab">
            <SendMessages />
          </div>
        </Card.Body>
      </Card>
    </div>
  );
}
